class Commons {
  buildMetadata(currentPage, totalPages, totalCount) {
    return {
      currentPage: Number(currentPage),
      totalPages: Number(totalPages),
      totalCount: Number(totalCount),
      nextPage: currentPage === totalPages ? 0 : Number(currentPage) + 1,
      prevPage: Number(currentPage) === 1 ? 0 : Number(currentPage) - 1,
    };
  }
}

const commonsHelper = new Commons();
export default commonsHelper;
